import type * as Types from 'app/types/graphql';

import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type ShopPlatformDuplicateThemeTemplateMutationVariables = Types.Exact<{
  input: Types.ShopPlatformDuplicateThemeTemplateInput;
}>;

export type ShopPlatformDuplicateThemeTemplateMutationResponse = Pick<
  Types.Mutation,
  'shopPlatformDuplicateThemeTemplate'
>;

export const ShopPlatformDuplicateThemeTemplateDocument = `
    mutation ShopPlatformDuplicateThemeTemplate($input: ShopPlatformDuplicateThemeTemplateInput!) {
  shopPlatformDuplicateThemeTemplate(input: $input)
}
    `;

export const useShopPlatformDuplicateThemeTemplateMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    ShopPlatformDuplicateThemeTemplateMutationResponse,
    TError,
    ShopPlatformDuplicateThemeTemplateMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    ShopPlatformDuplicateThemeTemplateMutationResponse,
    TError,
    ShopPlatformDuplicateThemeTemplateMutationVariables,
    TContext
  >(
    ['ShopPlatformDuplicateThemeTemplate'],
    (variables?: ShopPlatformDuplicateThemeTemplateMutationVariables) =>
      appFetcher<
        ShopPlatformDuplicateThemeTemplateMutationResponse,
        ShopPlatformDuplicateThemeTemplateMutationVariables
      >(ShopPlatformDuplicateThemeTemplateDocument, variables)(),
    options,
  );
};

useShopPlatformDuplicateThemeTemplateMutation.getKey = () => ['ShopPlatformDuplicateThemeTemplate'];
